import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Stack,
  Divider,
  useTheme,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import { Link as RouterLink } from 'react-router-dom';

function Footer() {
  const theme = useTheme();

  const footerSections = [
    {
      title: 'Useful Links',
      items: [
        { text: 'Home Loan Calculator', link: '/calculator' },
        { text: 'Find Property', link: '/home-loan' },
        { text: 'Home Loan', link: '/home-loan' },
      ],
    },
    {
      title: 'Home Loan Products',
      items: [
        { text: 'Home Loan Balance Transfer', link: '/home-loan' },
        { text: 'Home Renovation Loan', link: '/home-loan' },
        { text: 'Top Up on Home Loan', link: '/home-loan' },
      ],
    },
  ];

  return (
    <Box
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 8,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo and Company Info */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              component={RouterLink}
              to="/"
              sx={{
                color: 'white',
                textDecoration: 'none',
                fontWeight: 'bold',
                display: 'block',
                mb: 2,
              }}
            >
              Aaradhya Finance
            </Typography>
            <Stack spacing={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon fontSize="small" />
                <Link
                  href="mailto:info@aaradhyafinance.in"
                  sx={{ color: 'white', textDecoration: 'none', '&:hover': { color: theme.palette.secondary.main } }}
                >
                  info@aaradhyafinance.in
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon fontSize="small" />
                <Link
                  href="mailto:abhijeet@aaradhyafinance.in"
                  sx={{ color: 'white', textDecoration: 'none', '&:hover': { color: theme.palette.secondary.main } }}
                >
                  abhijeet@aaradhyafinance.in
                </Link>
              </Box>
            </Stack>
          </Grid>

          {/* Branches Column */}
          <Grid item xs={12} md={4}>
            {/* Registered Office - Virar */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                Registered Office - Virar
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <LocationOnIcon sx={{ mt: 0.5 }} />
                <Typography>
                  4th Floor, Siddi Manora Bldg., above IDBI bank, Opp. Ruchi Hotel, Virar (W) -401303
                </Typography>
              </Box>
            </Box>

            {/* Lucknow Branch */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                Lucknow Branch
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <LocationOnIcon sx={{ mt: 0.5 }} />
                <Typography>
                  C-2/161, Ansal Golf City, Near Ansal Main Gate, Lucknow
                </Typography>
              </Box>
            </Box>

            {/* Sangli Branch */}
            <Box>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                Sangli Branch
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <LocationOnIcon sx={{ mt: 0.5 }} />
                <Typography>
                  Office No. 1, Rahul Tower, CS No. 705/B, Above Pitke TV, Sangli Miraj Road, Sangli - 416416
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Links Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Quick Links
            </Typography>
            <Grid container spacing={2}>
              {footerSections.map((section) => (
                <Grid item xs={12} sm={6} key={section.title}>
                  <Typography variant="subtitle1" gutterBottom sx={{ color: theme.palette.secondary.main }}>
                    {section.title}
                  </Typography>
                  <Stack spacing={1}>
                    {section.items.map((item) => (
                      <Link
                        key={item.text}
                        component={RouterLink}
                        to={item.link}
                        sx={{
                          color: 'white',
                          textDecoration: 'none',
                          '&:hover': { color: theme.palette.secondary.main },
                        }}
                      >
                        {item.text}
                      </Link>
                    ))}
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' }} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {new Date().getFullYear()} Aaradhya Finance & Realty Pvt. Ltd. All Rights Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;